import { Outlet } from 'react-router-dom';
import PublicLayout from 'src/layout/PublicLayout';

const PublicRoute = () => (
  <PublicLayout>
    <Outlet />
  </PublicLayout>
);

export default PublicRoute;
